// extracted by mini-css-extract-plugin
export var menuIcon = "_tz-0";
export var menuIconInline = "_tz-1";